import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button, Divider } from 'antd';
import { ReactComponent as MaleReferralSvg } from '../../../assets/icons/referral/male-referral.svg';
import { ReactComponent as SignalSvg } from '../../../assets/icons/user-account/signal.svg';
import { ReactComponent as TelegramSvg } from '../../../assets/icons/user-account/telegram.svg';
import { ReactComponent as ViberSvg } from '../../../assets/icons/user-account/viber.svg';
import { ReactComponent as WhatsappSvg } from '../../../assets/icons/user-account/whatsapp.svg';
import ButtonFooter from '../../../components/mobile/ButtonFooter';

const { Title } = Typography;

function MobileFeedbackFinishScreen() {
  const { t } = useTranslation(['common', 'feedback']);
  const history = useHistory();

  const onShare = () => {

  }

  const onClose = () => {
    history.push('/homepage');
  }

  return (
    <>
      <Box display="flex" justifyContent="center">
        <MaleReferralSvg style={{ margin: '20', maxWidth: '80%' }} />
      </Box>
      <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
        <Col>
          <Title level={4} style={styles.title}>
            {t('feedback:spreadTheWorld')}
          </Title>
        </Col>
      </Row>
      <Box marginBottom={20}>
        <Divider plain><p style={styles.divider}>{t('feedback:shareUsing')}</p></Divider>
      </Box>
      <Row justify="center" align="middle" style={{ padding: 0}}>
        <Col xs={6}>
          <Row justify="center" align="middle">
            <ViberSvg onClick={onShare} />
          </Row>
        </Col>
        <Col xs={6}>
          <Row justify="center" align="middle">
            <SignalSvg onClick={onShare} />
          </Row>
        </Col>
        <Col xs={6}>
          <Row justify="center" align="middle">
            <WhatsappSvg onClick={onShare} />
          </Row>
        </Col>
        <Col xs={6}>
          <Row justify="center" align="middle">
            <TelegramSvg onClick={onShare} />
          </Row>
        </Col>
      </Row>
      <ButtonFooter
        title={t('referral:close')}
        onClick={onClose}
      />
    </>
  );
}

const styles = {
  title: {
    fontWeight: "700", 
    fontSize: "24px", 
    lineHeight: "29px", 
    textAlign: "center", 
    textTransform: "capitalize", 
    color: "#15A9E1"
  },
  subtitle: {
    fontWeight: "300", 
    fontSize: "18px", 
    lineHeight: "28px", 
    textAlign: "center", 
    color: "#404047"
  },
  divider: {
    fontWeight: "500", 
    fontSize: "18px", 
    lineHeight: "22px", 
    textAlign: "center", 
    color: "#15A9E1",
    margin: 0
  },
};

export default MobileFeedbackFinishScreen;
